import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Faq from "react-faq-component";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { Transaction_Forum } from "../../Connections/Transaction";

import Page from "../Page/Page";

import "../../Styles/News.css";

const News = (props) => {
  const navigator = useNavigate();

  // ====================================================

  const [FAQ, setFAQ] = useState({});

  // ====================================================

  const config = {
    animate: true,
    openOnload: -1,
  };

  // ====================================================

  useEffect(() => {
    Transaction_Forum.GetNews().then((res) => {
      if (res[0]) {
        const x = [];
        res[2].data.map((item) => {
          x.push({
            title: (
              <div style={{ fontFamily: "inherit" }}>
                <span
                  style={{
                    marginLeft: "12px",
                    fontFamily: "inherit",
                  }}
                >
                  {item.title}
                </span>
                <br className="desktop-hidden" />
                <span
                  style={{
                    fontFamily: "inherit",
                    fontSize: "12px",
                  }}
                >
                  {`( ${item.date} )`}
                </span>
              </div>
            ),
            content: (
              <>
                <div dangerouslySetInnerHTML={{ __html: item.text }} />
                {/* {item.text}
                <br />
                <br />
                {item.img ? (
                  <img src={item.img} alt="news img" className="w-100" />
                ) : null} */}
              </>
            ),
          });
        });
        setFAQ({ rows: x });
      }
    });
  }, []);

  // ====================================================

  return (
    <Page>
      <MobileNavBar
        text="اخبار کتابنو"
        action={() => navigator("/hisstori/blog")}
      />
      <div className="News_wrapper">
        <div
          className="News_back-arrow mobile-hidden"
          onClick={() => navigator("/hisstori/blog")}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <img src="/imgs/Blog/News-icon.svg" alt="hand speaker icon" />
        <h1>اخبار کتابنو</h1>
        <div className="News_alerts-container number-font">
          <Faq data={FAQ} config={config} />
        </div>
      </div>
    </Page>
  );
};

export default News;
